/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  PostgrestConfigWithJWTSecretResponse,
  V1PostgrestConfigResponse,
  V1UpdatePostgrestConfigBody
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * @summary Gets project's postgrest config
 */
export type v1GetPostgrestServiceConfigResponse200 = {
  data: PostgrestConfigWithJWTSecretResponse
  status: 200
}

export type v1GetPostgrestServiceConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetPostgrestServiceConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetPostgrestServiceConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetPostgrestServiceConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetPostgrestServiceConfigResponseSuccess = (v1GetPostgrestServiceConfigResponse200) & {
  headers: Headers;
};
export type v1GetPostgrestServiceConfigResponseError = (v1GetPostgrestServiceConfigResponse401 | v1GetPostgrestServiceConfigResponse403 | v1GetPostgrestServiceConfigResponse429 | v1GetPostgrestServiceConfigResponse500) & {
  headers: Headers;
};

export type v1GetPostgrestServiceConfigResponse = (v1GetPostgrestServiceConfigResponseSuccess | v1GetPostgrestServiceConfigResponseError)

export const getV1GetPostgrestServiceConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/postgrest`
}

export const v1GetPostgrestServiceConfig = async (ref: string, options?: RequestInit): Promise<v1GetPostgrestServiceConfigResponse> => {
  
  return customFetch<v1GetPostgrestServiceConfigResponse>(getV1GetPostgrestServiceConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Updates project's postgrest config
 */
export type v1UpdatePostgrestServiceConfigResponse200 = {
  data: V1PostgrestConfigResponse
  status: 200
}

export type v1UpdatePostgrestServiceConfigResponse401 = {
  data: void
  status: 401
}

export type v1UpdatePostgrestServiceConfigResponse403 = {
  data: void
  status: 403
}

export type v1UpdatePostgrestServiceConfigResponse429 = {
  data: void
  status: 429
}

export type v1UpdatePostgrestServiceConfigResponse500 = {
  data: void
  status: 500
}

export type v1UpdatePostgrestServiceConfigResponseSuccess = (v1UpdatePostgrestServiceConfigResponse200) & {
  headers: Headers;
};
export type v1UpdatePostgrestServiceConfigResponseError = (v1UpdatePostgrestServiceConfigResponse401 | v1UpdatePostgrestServiceConfigResponse403 | v1UpdatePostgrestServiceConfigResponse429 | v1UpdatePostgrestServiceConfigResponse500) & {
  headers: Headers;
};

export type v1UpdatePostgrestServiceConfigResponse = (v1UpdatePostgrestServiceConfigResponseSuccess | v1UpdatePostgrestServiceConfigResponseError)

export const getV1UpdatePostgrestServiceConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/postgrest`
}

export const v1UpdatePostgrestServiceConfig = async (ref: string,
    v1UpdatePostgrestConfigBody: V1UpdatePostgrestConfigBody, options?: RequestInit): Promise<v1UpdatePostgrestServiceConfigResponse> => {
  
  return customFetch<v1UpdatePostgrestServiceConfigResponse>(getV1UpdatePostgrestServiceConfigUrl(ref),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1UpdatePostgrestConfigBody,)
  }
);}
  

